import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    isLoading: false,
    _isActuallyLoading: false,
    _showTimer: null as ReturnType<typeof setTimeout> | null,
    _hideTimer: null as ReturnType<typeof setTimeout> | null,
    loadingDelay: 250,
    minSpinnerTime: 750,
  }),

  actions: {
    startLoading() {
      this._isActuallyLoading = true;

      if (this._hideTimer) {
        clearTimeout(this._hideTimer);
        this._hideTimer = null;
      }

      this._showTimer = setTimeout(() => {
        if (this._isActuallyLoading) {
          this.isLoading = true;
        }
      }, this.loadingDelay);
    },

    stopLoading() {
      this._isActuallyLoading = false;

      if (!this.isLoading) {
        clearTimeout(this._showTimer!);
        this._showTimer = null;
        return;
      }

      this._hideTimer = setTimeout(() => {
        this.isLoading = false;
        this._hideTimer = null;
      }, this.minSpinnerTime);
    },
  },
});
